/*global chrome*/
import React from "react";
import $ from "jquery";

export default class MapSearch extends React.Component {

    componentDidMount(){
        const jsScript = document.createElement("script");
        jsScript.src = "./js/autosuggest.js";
        jsScript.async = true;
        document.body.appendChild(jsScript);

        const script1 = document.createElement("script");
        script1.src = "https://www.bing.com/api/maps/mapcontrol?callback=GetMap&key=AqI_gbQoYcti6pRLn7T6Eqk_oWBguOwzq70AFwhN1x1EeMPBQbMf3IYiT_yoilNk";
        script1.async = true;
        document.body.appendChild(script1);
    }

    render() {
        return (
            <div>
                <div className='searchBoxContainer'>
                    <input list="topbar_autosearch topbarsearch" 
                        className="searchBox" 
                        placeholder="Enter Any Location" 
                        aria-label="Search"
                        autoComplete="off"
                    />
                </div>
                {/* <div id='myMap'></div> */}
                <button className="btn-blue" id='continue' type='button'>
                    Continue <i className="fas fa-angle-right"></i>
                </button>
            </div>
        )
    }

}